import React, { useState, useEffect } from 'react'
import { Api, Endpoint } from '../api'
import { useRouteMatch } from 'react-router-dom'
import { store } from '../store-redux/connect/store'
import styles from '../Templates/Classic Template/SingleMenuPage/SingleMenuPage.module.scss'
import LoadingSpinner from '../components/LoadingSpinner'
import backimg from '../images/foodi-footer.png'
import { IKImage } from 'imagekitio-react'
import general from '../helpers/general'

const withMenu = (BaseComponent) => (props) => {
	const [loading, setLoading] = useState(true)
	const [customerMenu, setCustomerMenu] = useState(null)
	const [data, setData] = useState(null)
	const [menusTimeline, setMenusTimeline] = useState(null)

	// eslint-disable-next-line
	const {
		Auth,
		Restaurant: { restaurant, find },
	} = store.getState()

	const matchMenuId = useRouteMatch('/menu/:id')
	const matchOrderId = useRouteMatch('/order/:id')
	const match = matchMenuId || matchOrderId

	const matchMenuMap = useRouteMatch('/menu/:restaurantId/:mapId')
	const matchOrderMap = useRouteMatch('/order/:restaurantId/:mapId')
	const matchMap = matchMenuMap || matchOrderMap

	const isOrderRoute = !!(matchOrderId || matchOrderMap)

	const [customerOrderingScopes, setCustomerOrderingScopes] = useState(null)

	const fetchCustomerOrderingScopes = async (restaurantId) => {
		if (!restaurantId) {
			setCustomerOrderingScopes(null)
			return
		}
		try {
			const resp = await Api.call(Endpoint.customerOrderingScopes, {
				params: [restaurantId, 'ordering-scopes'],
			})
			if (resp?.confirmation === 'Success' && resp?.message) {
				setCustomerOrderingScopes(resp.message)
			} else {
				setCustomerOrderingScopes(null)
			}
		} catch {
			setCustomerOrderingScopes(null)
		}
	}

	const getCustomerMenu = async (id, mapId) => {
		const params = {
			params: [id],
		}
		if (mapId) {
			params.params.push(mapId)
		}

		const resp = await Api.call(Endpoint.getCustomerMenu, params)

		if (!resp || resp?.confirmation === 'Fail' || !resp?.message || !resp?.message?.restaurant) {
			// setMenuNotFound(true);
			return resp
		}

		// if (resp?.message?.menuNotFound) {
		//   // setMenuNotFound(true);
		// } else {
		//   // setMenuNotFound(false);
		// }

		setCustomerMenu(resp?.message)
		setMenusTimeline(resp?.message?.menusTimeline)
		adminSocialFallback(resp?.message?.restaurant)

		document.title = resp?.message?.restaurant?.name
		return resp
	}

	const adminSocialFallback = (restaurantData) => {
		if (!restaurantData) {
			return
		}

		const adminSocials = [
			{ media: 'facebook', icon: 'fab fa-facebook-f', url: process.env.REACT_APP_FOODI_FB },
			{ media: 'instagram', icon: 'fab fa-instagram', url: process.env.REACT_APP_FOODI_IN },
			{ media: 'twitter', icon: 'fab fa-twitter', url: process.env.REACT_APP_FOODI_TW },
			{ media: 'yelp', icon: 'fab fa-yelp', url: process.env.REACT_APP_FOODI_YE },
			{ media: 'website', icon: 'fab fa-web', url: process.env.REACT_APP_FOODI_WEB },
		]

		let restaurant = { ...restaurantData }

		if (restaurantData?.social) {
			adminSocials.forEach((adminMedia) => {
				if (restaurantData?.parentRestaurant) {
					restaurantData.parentRestaurant?.social?.forEach((media) => {
						if (adminMedia.media === media.media && media.url !== '') {
							adminMedia.url = media.url
						}
					})
				}
				restaurantData.social.forEach((media) => {
					if (adminMedia.media === media.media && media.url !== '') {
						adminMedia.url = media.url
					}
				})
			})
			restaurant = { ...restaurantData, social: adminSocials }
		}

		setData(restaurant)
	}

	const init = async () => {
		setLoading(true)
		setData(null)
		setCustomerMenu(null)
		setMenusTimeline(null)
		if (Auth.LOGGED_IN()) {
			await find()
		}
		if (match?.params?.id) {
			const resp = await getCustomerMenu(match?.params?.id)
			setCustomerMenu(resp?.message)
			await fetchCustomerOrderingScopes(match?.params?.id)
		} else if (matchMap?.params?.restaurantId && matchMap?.params?.mapId) {
			const resp = await getCustomerMenu(matchMap?.params?.restaurantId, matchMap?.params?.mapId)
			setCustomerMenu(resp?.message)
			await fetchCustomerOrderingScopes(matchMap?.params?.restaurantId)
		} else {
			setCustomerOrderingScopes(null)
		}
		setLoading(false)
	}

	const routeRestaurantId = match?.params?.id || matchMap?.params?.restaurantId
	const routeMapId = matchMap?.params?.mapId

	useEffect(() => {
		init()
		//eslint-disable-next-line
	}, [routeRestaurantId, routeMapId])

	useEffect(() => {
		console.log({ customerMenu })
	}, [customerMenu])

	useEffect(() => {
		if (restaurant && typeof restaurant === 'object' && restaurant?._id && !match && !matchMap) {
			getCustomerMenu(restaurant?._id)
		}
		//eslint-disable-next-line
	}, [restaurant])

	if (loading) {
		return (
			<div className={styles.centeredWrapper}>
				<LoadingSpinner text={true} />
			</div>
		)
	} else if (isOrderRoute && customerMenu?.restaurant?.acceptOrders === false) {
		return (
			<div className={styles.centeredWrapper}>
				<h2>Not currently accepting orders</h2>
			</div>
		)
	} else if (customerMenu?.menuNotFound) {
		return (
			<div className={styles.centeredWrapper}>
				{customerMenu?.restaurant?.logo ? (
					<IKImage
						path={customerMenu?.restaurant?.logo}
						transformation={[{ width: 100, height: 100 }]}
						style={{ width: '100px', height: '100px', objectFit: 'contain' }}
						loading="lazy"
						lqip={{ active: true }}
						alt={customerMenu?.restaurant?.title}
					/>
				) : (
					<div
						style={{
							padding: 10,
							marginBottom: 40,
							width: 100,
							height: 100,
							borderRadius: '50%',
							backgroundColor: 'var(--brand)',
						}}
					>
						<img src={backimg} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="" />
					</div>
				)}
				<div style={{ padding: '0 30px', textAlign: 'center' }}>
					<h2>There are no published menus</h2>
					<p style={{ margin: '30px' }}>
						Please{' '}
						<a
							href={`mailto:${customerMenu?.user?.email}`}
							target="_blank"
							rel="noreferrer"
							style={{ color: 'var(--brand)' }}
						>
							notify
						</a>{' '}
						the {general.convertToReadableRestaurantType(customerMenu?.restaurant?.restaurantType)} that
						they need to publish it
					</p>
				</div>
			</div>
		)
	}

	return (
		<>
			<BaseComponent
				{...props}
				data={data}
				loading={loading}
				menuNotFound={Boolean(customerMenu?.menuNotFound)}
				menusTimeline={menusTimeline}
				getCustomerMenu={getCustomerMenu}
				preview={props.preview}
				customerOrderingScopes={customerOrderingScopes}
				isOrderRoute={isOrderRoute}
			/>
		</>
	)
}

export default withMenu
